import React from 'react';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LanguageIcon from '@mui/icons-material/Language';
import { Avatar, Grid, Stack } from '@mui/material';

import './desktopFooter.scss';
 
export default function DesktopFooter () {
    return (
        <>
            <div className='home-interno-footer'>
                <Grid container direction="row" spacing={0} sx={{ width: '100%' }}>
 <Grid size={{ md: 12 }}>
                        Seguinos en nuestras redes sociales
                    </Grid>
                    <br /><br />
 <Grid size={{ md: 4, lg: 4 }}>
                        <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                            <a href='https://www.linkedin.com/company/nutrihome-s-a' underline="none" color="white" target='_blank'>
                                <Avatar sx={{ bgcolor: 'white', color: '#005CB9', width: 30, height: 30 }}>
                                    <LinkedInIcon />
                                </Avatar>           
                            </a>  
                            <a href='https://www.instagram.com/nutrihome.argentina/' underline="none" color="white" target='_blank'>
                                <Avatar sx={{ bgcolor: 'white', color: '#005CB9', width: 30, height: 30 }}>
                                    <InstagramIcon />
                                </Avatar>                                
                            </a>
                            <a href='https://www.facebook.com/profile.php?id=100090047415999' underline="none" color="white" target='_blank'>
                                <Avatar sx={{ bgcolor: 'white', color: '#005CB9', width: 30, height: 30 }}>
                                    <FacebookIcon />
                                </Avatar>                                
                            </a>
                        </Stack>
                    </Grid>
 <Grid size={{ md: 4, lg: 4 }}>
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Avatar sx={{ bgcolor: 'white', color: '#005CB9', width: 30, height: 30 }}>
                                <LanguageIcon />
                            </Avatar> 
                            <div style={{ paddingTop: '5px' }}><a href="https://www.nutrihome.com.ar" underline="none" color="white" target='_blank' title='Ir a la página de Nutrihome'>www.nutrihome.com.ar</a></div>
                        </div>
                    </Grid>
 <Grid size={{ md: 4, lg: 4 }}>
                        <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                            <Avatar sx={{ bgcolor: 'white', color: '#005CB9', width: 30, height: 30 }}>
                                <LanguageIcon />
                            </Avatar> 
                            <div style={{ paddingTop: '5px' }}><a href="https://www.carehome.com.ar" underline="none" color="white" target='_blank' title='Ir a la página de Carehome'>www.carehome.com.ar</a></div>
                        </div>
                    </Grid>
                </Grid>                    
            </div>
        </>
    )
}